<template>
  <div>
    <h1>Contactos</h1>
    <button class="btn btn-success mb-3" @click="showForm = true">
      Agregar Contacto
    </button>

    <!-- Formulario modal/simple para agregar contacto -->
    <div v-if="showForm" class="mb-4 border p-3">
      <Form
        v-if="fields.length"
        :fields="fields"
        :model="newContact"
        submitLabel="Guardar"
        @save="handleSaveContact"
      />
      <div v-else>Cargando formulario...</div>
      <button class="btn btn-secondary mt-2" @click="showForm = false">
        Cancelar
      </button>
    </div>

    <List :items="contacts" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import Form from "@/components/gotrading/common/Form.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "ContactsPage",
  components: { List, Form },
  data() {
    return {
      contacts: [],
      showForm: false,
      newContact: {},
      columns: [
        { key: "name", label: "Nombre" },
        { key: "referenceNumber", label: "N° Referencia" },
        { key: "language", label: "Idioma" },
        { key: "type", label: "Tipo" },
        { key: "country", label: "País" },
        { key: "city", label: "Ciudad" },
        { key: "emails", label: "Emails" },
        { key: "phones", label: "Teléfonos" },
      ],
      fields: [],
      fieldTypes: {}, // Guardará el tipo de cada campo
    };
  },
  async mounted() {
    await this.fetchContacts();
    await this.buildFields();
  },
  methods: {
    async fetchContacts() {
      try {
        const response = await wencesApi.get("/api/gotrading/contacts");
        this.contacts = response.data;
      } catch (error) {
        console.error("Error al obtener contactos:", error);
      }
    },
    async buildFields() {
      // Campos base
      const baseFields = [
        { key: "name", label: "Nombre", type: "text" },
        { key: "reference", label: "Referencia", type: "text" },
        { key: "emails", label: "Emails", type: "text" },
        { key: "phones", label: "Teléfonos", type: "text" },
        {
          key: "address",
          label: "Dirección",
          type: "group",
          fields: [
            { key: "country", label: "País", type: "text" },
            { key: "city", label: "Ciudad", type: "text" },
            { key: "address", label: "Dirección", type: "text" },
            { key: "postalCode", label: "Código Postal", type: "text" },
          ],
        },
      ];

      // Pide los tipos de campo
      const fieldsRes = await wencesApi.get(
        "/api/gotrading/models/Contact/fields"
      );
      this.fieldTypes = {};
      fieldsRes.data.forEach((f) => {
        this.fieldTypes[f.key] = f.type;
      });

      // Pide los mapeos para Contact
      const mappingsRes = await wencesApi.get(
        "/api/gotrading/field-list-mappings?model=Contact"
      );
      const mappings = mappingsRes.data;

      // Para cada mapeo, pide el listado y arma el campo como select
      for (const mapping of mappings) {
        const listRes = await wencesApi.get(
          `/api/gotrading/lists/${mapping.list._id}`
        );
        // Soporta tanto arrays de objetos como de strings
        const options = listRes.data.values.map((val) => ({
          value: val._id || val,
          label: val.label || val,
        }));
        const idx = baseFields.findIndex((f) => f.key === mapping.field);
        const selectField = {
          key: mapping.field,
          label: mapping.field.charAt(0).toUpperCase() + mapping.field.slice(1),
          type: "select",
          options,
        };
        if (idx !== -1) {
          baseFields[idx] = selectField;
        } else {
          baseFields.push(selectField);
        }
      }

      this.fields = baseFields;
    },
    async handleSaveContact(contact) {
      // Ajusta los valores según el tipo de campo
      for (const field in contact) {
        const type = this.fieldTypes[field];
        if (type === "list") {
          // Ya tienes el _id seleccionado, no hagas nada
        } else if (type === "string" || type === "number") {
          // Si el value es un objeto (por ejemplo, { value: 'French', label: 'French' }), extrae el value
          if (contact[field] && contact[field].value) {
            contact[field] = contact[field].value;
          }
        }
      }
      try {
        await wencesApi.post("/api/gotrading/contacts", contact);
        this.showForm = false;
        this.newContact = {};
        await this.fetchContacts();
      } catch (error) {
        console.error("Error al guardar contacto:", error);
      }
    },
  },
};
</script>
